import React from 'react'
import { Grid } from '@material-ui/core'
import ResourceItem from './ResourceItem'
const Resources = (data) => {
  return (
    <Grid className='container' container alignItems='stretch' spacing={3}>
      {data.data && data.data.length > 0 ? (
        data.data.map((post) => (
          <Grid key={post._id} item xs={6} md={3}>
            <ResourceItem post={post} />
          </Grid>
        ))
      ) : (
        <p style={{ flexBasis: '100%', padding: '0px 20px', fontSize: '20px' }}>
          No files have been uploaded yet
        </p>
      )}
    </Grid>
  )
}

export default Resources
